<template>
  <div>
    <StepHeader title="Are You Working While in School?"/>
    <StepContent
      width="md"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        :value="employed_in_school"
        flex-row
        label="Please Select"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="handleContinue"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Your employment status will help determine the best vehicle and financing options for you.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'

export default {
  // Name
  name: 'employment-student',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'emp_status_student',
      fieldName: 'employed_in_school',
      buttons: [{
        text: 'Yes',
        value: 'Yes',
        isEmployed: true,
        datalayer: 'yes'
      }, {
        text: 'No',
        value: 'No',
        isEmployed: false,
        datalayer: 'no'
      }]
    }
  },

  // Computed
  computed: {
    employed_in_school () {
      return this.$store.state.application[this.fieldName]
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    selectedButton () {
      if (!this[this.fieldName]) return
      return this.buttons.find(button => button.value === this[this.fieldName])
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      return `${this.datalayerStepName}_${this.selectedButton.datalayer}`
    }
  },

  // Created
  created () {
    if (!this[this.fieldName]) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      if (event !== this.employed_in_school) {
        this.$store.updateApplication('income_type', undefined)
        this.$store.updateApplication('income_value', undefined)
        this.$store.updateApplication('income_hours', undefined)
      }

      this.$store.updateApplication(this.fieldName, event)
      this.$store.updateEmployment(this.selectedButton.isEmployed)
    },

    handleContinue () {
      this.shouldSetAsEmployed()
      this.$emit('next')
    },

    /**
     * Sets the students source_of_income as "Employed" if the student is working while in school.
     * @returns {void}
    */
    shouldSetAsEmployed () {
      this.employed_in_school.toLowerCase() === 'yes'
        ? this.$store.updateApplication('source_of_income', 'Employed')
        : this.$store.updateApplication('source_of_income', 'Student')
    }
  }
}
</script>

<style>
</style>
